<template>
  <div>
    <el-date-picker v-model="value" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="placeholder" type="datetime" @input="onChange" />
  </div>
</template>

<script>
export default {
  name: 'DateTimeSelect',
  data () {
    return {
      value: null
    }
  },
  props: {
    placeholder: String
  },
  methods: {
    onChange: function (value) {
      this.value = value
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DateTimeSelect/index.vue